module.exports = __webpack_public_path__ + "5b12f165f887adde4d4ac9362603489d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/style/fonts/GT-Walsheim-Pro-Regular.ttf
// module id = 403
// module chunks = 0